import React from 'react';

import './authentication-layout.scss';

export const AuthenticationLayout: React.FC = ({ children }): React.ReactElement => {
    return (
        <div className="authentication-layout">
            <div className="authentication-layout__content-wrapper">
                <img alt="Prizeout" src="https://assets.prizeout.com/branding/po-logo-full-white.svg" width={100} />
                {children}
            </div>
        </div>
    );
};
